import { createAsyncTypes } from 'utils/ActionCreator'

export const CHANGE_WIZARD_INDEX = 'Settings/Notifications/CollaborationApps/CHANGE_WIZARD_INDEX'
export const SELECT_APP = 'Settings/Notifications/CollaborationApps/SELECT_APP'

export const UPDATE_WEBHOOK_URL = 'Settings/Notifications/CollaborationApps/UPDATE_WEBHOOK_URL'
export const FETCH_SLACK_DATA_REQUEST = createAsyncTypes(
  'FETCH_SLACK_DATA_REQUEST',
  'Notifications/CollaborationApps'
)
export const FETCH_TEAMS_DATA_REQUEST = createAsyncTypes(
  'FETCH_TEAMS_DATA_REQUEST',
  'Notifications/CollaborationApps'
)

export const UPDATE_COLLABORATION_APP_ALERTS_REQUEST = createAsyncTypes(
  'UPDATE_COLLABORATION_APP_ALERTS_REQUEST',
  'Notifications/CollaborationApps'
)

export const UPDATE_NOTIFICATIONS_REQUEST = createAsyncTypes(
  'UPDATE_NOTIFICATIONS_REQUEST',
  'Notifications/CollaborationApps'
)
export const CANCEL_INTEGRATION_REQUEST = createAsyncTypes(
  'CANCEL_INTEGRATION_REQUEST',
  'Notifications/CollaborationApps'
)

export const APPS_LIST_CONST = [
  {
    name: 'slack',
    value: 1,
    icon: '/static/webapp/images/settings/slack-icon.svg',
    kbLink: 'https://support.ironscales.com/hc/en-us/articles/360016851519',
    appSteps: 'slackSteps',
    displayName: 'Slack',
    disabledImg: '/static/webapp/images/Slack-widget.svg',
  },
  {
    name: 'teams',
    value: 2,
    icon: '/static/webapp/images/settings/teams-icon.svg',
    kbLink: 'https://support.ironscales.com/hc/en-us/articles/360017299880',
    appSteps: 'teamsSteps',
    displayName: 'Microsoft Teams',
    disabledImg: '/static/webapp/images/Teams-widget.svg',
  },
]

export const SLACK_CONST = 1

export const ALERTS_LIST = [
  {
    value: 'notProtectedMailboxes',
    key: 'not_protected_mailboxes',
    text: 'Mailboxes enabled but not protected',
  },
  {
    value: 'userChangePermissions',
    key: 'user_change_permissions',
    text: 'User permissions changes',
  },
  {
    value: 'integrationDisabled',
    key: 'integration_disabled',
    text: 'Mail Server Integration was disabled',
  },
  {
    value: '911Disabled',
    key: '911_disabled',
    text: '911 Integration was disabled',
  },
  {
    value: 'autoSyncFailed',
    key: 'auto_sync_failed',
    text: 'Auto-sync: Failure in uploading mailboxes',
  },
  {
    value: 'newRelease',
    key: 'new_release',
    text: 'New release is available',
  },
  {
    value: 'classifiedIncident',
    key: 'classified_incident',
    text: 'An Incident was classified',
  },
  {
    value: 'openIncidents',
    key: 'open_incidents',
    text: 'You have Open Incidents',
  },
  {
    value: 'newIncident',
    key: 'new_incident',
    text: 'New incident was opened',
  },
  {
    value: 'licenseExpiry',
    key: 'license_expiry',
    text: 'Licenses are about to expire',
  },
  {
    value: 'licenseLimit',
    key: 'license_limit',
    text: 'License limit reached',
  },
]
